import React, {useState, useEffect, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import {LoadingSpinner, BadgeChange, useBlockerWithModal} from '../../common/component_common.js';
import {isValidEmail, showToast} from '../../common/app_common.js';
import {getApiConfigEndpointStatus, getApiConfigEndpoint, postApiConfigEndpoint} from '../../common/fetch_api/configuration'
import {postApiConfigEndpointEmailTest, postApiConfigEndpointSlackTest, postApiConfigEndpointTeamsTest, postApiConfigEndpointTelegramTest} from '../../common/fetch_api/configuration_test'
import {BsEnvelope, BsSlack, BsMicrosoftTeams, BsTelegram} from 'react-icons/bs'
import {DecideWindow} from '../../common/modal_common.js';

export const View = ({existUpdate, setExistUpdate}) => {
    
    const [update, setUpdate] = useState(false);

    const [emailConfig, setEmailConfig] = useState({used: "false", color:"", available:false, address:"", password:"", port:"", protocol:"", receiveAddress:"", server:""});
    const [slackConfig, setSlackConfig] = useState({used: "false", color:"", available:false, webhook:""});
    const [teamsConfig, setTeamsConfig] = useState({used: "false", color:"", available:false, webhook:""});
    const [telegramConfig, setTelegramConfig] = useState({used: "false", color:"", available:false, botToken:"", chatId:""});

    const [emailOrigin, setEmailOrigin] = useState({used: "false", color:"", available:false, address:"", password:"", port:"", protocol:"", receiveAddress:"", server:""});
    const [slackOrigin, setSlackOrigin] = useState({used: "false", color:"", available:false, webhook:""});
    const [teamsOrigin, setTeamsOrigin] = useState({used: "false", color:"", available:false, webhook:""});
    const [telegramOrigin, setTelegramOrigin] = useState({used: "false", color:"", available:false, botToken:"", chatId:""});

    const [loading, setLoading] = useState(false);


    const [modalVisible, setModalVisible] = useState(false);
    const [modalCallback, setModalCallback] = useState(null);

    const showModalDecideForRoute = ({ onConfirm }) => {
        setModalVisible(true);
        setModalCallback(() => onConfirm);
    };
    const closeModalDecideForRoute = () => {
        setModalVisible(false);
    };

    useBlockerWithModal(existUpdate, showModalDecideForRoute);

    // DecideWindow에서 OK 클릭 시
    const handleModalOk = (is) => {
        if( is )
        {
            setModalVisible(false);
            if (modalCallback) modalCallback();
        }
    };

    const SetDecideBodyMoveout = () => {
        return (
            <div className='text-center'>
                <p>There are unsaved changes. Are you sure you want to leave this page?</p>
            </div>
    )};

    const getConfigEndpointRef = useRef(false);

    function getEndpotintStatus()
    {
        Promise.all( [getApiConfigEndpointStatus(), getApiConfigEndpoint()] )
        .then( ([statusArr, configArr]) => {
            
            let emailTemp = emailConfig;
            let slackTemp = slackConfig;
            let teamsTemp = teamsConfig;
            let telegramTemp = telegramConfig;

            for( let status of statusArr )
            {
                if( status.endpoint === 'email' )
                {
                    emailTemp.available = status.available;
                }
                else if( status.endpoint === 'slack' )
                {
                    slackTemp.available = status.available;
                }
                else if( status.endpoint === 'teams' )
                {
                    teamsTemp.available = status.available;
                }
                else if( status.endpoint === 'telegram' )
                {
                    telegramTemp.available = status.available;
                }
            }

            emailTemp.used = String(configArr.email.use);
            emailTemp.address = configArr.email.address;
            emailTemp.password = configArr.email.password;
            emailTemp.port = configArr.email.port;
            emailTemp.protocol = configArr.email.protocol;
            emailTemp.receiveAddress = configArr.email.receiveAddress;
            emailTemp.server = configArr.email.server;
            
            slackTemp.used = String(configArr.slack.use);
            slackTemp.webhook = configArr.slack.webhook;
            
            teamsTemp.used = String(configArr.teams.use);
            teamsTemp.webhook = configArr.teams.webhook;
            
            telegramTemp.used = String(configArr.telegram.use);
            telegramTemp.botToken = configArr.telegram.botToken;
            telegramTemp.chatId = configArr.telegram.chatId;

            emailTemp.color = getStatusColor(configArr.email.use, emailTemp);
            slackTemp.color = getStatusColor(configArr.slack.use, slackTemp);
            teamsTemp.color = getStatusColor(configArr.teams.use, teamsTemp);
            telegramTemp.color = getStatusColor(configArr.telegram.use, telegramTemp);

            setEmailOrigin(emailTemp);
            setSlackOrigin(slackTemp);
            setTeamsOrigin(teamsTemp);
            setTelegramOrigin(telegramTemp);

            setEmailConfig(emailTemp);
            setSlackConfig(slackTemp);
            setTeamsConfig(teamsTemp);
            setTelegramConfig(telegramTemp);

            getConfigEndpointRef.current = true;
        });
    }

    function getStatusColor(use, config)
    {
        if(use)
        {
            if( config.available )
                return "bg-good";
            else
                return "bg-warning";
        }
        else
        {
            return "bg-gray";
        }
    }

    const onClickEmailTest = () => {
        // 발신자 이메일 주소 유효성 검사
        if (!isValidEmail(emailConfig.address)) {
            showToast('Please enter a valid E-Mail Address (e.g., user@example.com)', 'warning');
            return;
        }

        // 수신자 이메일 주소 유효성 검사
        if (!isValidEmail(emailConfig.receiveAddress)) {
            showToast('Please enter a valid Receive E-Mail Address (e.g., user@example.com)', 'warning');
            return;
        }

        setLoading(true);

        let sendData = {
            "protocol": emailConfig.protocol,
            "port": emailConfig.port,
            "server": emailConfig.server,
            "address": emailConfig.address,
            "password": emailConfig.password,
            "receiveAddress": emailConfig.receiveAddress
        };

        Promise.resolve( postApiConfigEndpointEmailTest(sendData) )
        .then( done => {
            // runUpdate();
            setLoading(false);
        })
        .catch( e=> {
            setLoading(false);
            // console.log(e);
        });
    }

    const onClickSlackTest = () => {
        setLoading(true);
        
        let sendData = {
            "webhook": slackConfig.webhook,
        };

        Promise.resolve( postApiConfigEndpointSlackTest(sendData) )
        .then( done => {
            // runUpdate();
            setLoading(false);
        })
        .catch( e=> {
            setLoading(false);
            // console.log(e);
        });
    }

    const onClickTeamsTest = () => {
        setLoading(true);
        
        let sendData = {
            "webhook": teamsConfig.webhook,
        };

        Promise.resolve( postApiConfigEndpointTeamsTest(sendData) )
        .then( done => {
            // runUpdate();
            setLoading(false);
        })
        .catch( e=> {
            setLoading(false);
            // console.log(e);
        });
    }

    const onClickTelegramTest = () => {
        setLoading(true);

        let sendData = {
            "botToken": telegramConfig.botToken,
            "chatId": telegramConfig.chatId,
        };

        Promise.resolve( postApiConfigEndpointTelegramTest(sendData) )
        .then( done => {
            // runUpdate();
            setLoading(false);
        })
        .catch( e=> {
            setLoading(false);
            // console.log(e);
        });
    }

    const onChangeState = (e, category, index, state) => {
        let temp = { ...state };
        temp[index] = e.target.value;

        if( category === 'email' )
        {
            setEmailConfig(temp);
        }
        else if( category === 'slack' )
        {
            setSlackConfig(temp);
        }
        else if( category === 'teams' )
        {
            setTeamsConfig(temp);
        }
        else if( category === 'telegram' )
        {
            setTelegramConfig(temp);
        }
    }

    const onClickSave = () => {
        // 발신자 이메일 주소 유효성 검사
        if (!isValidEmail(emailConfig.address)) {
            showToast('Please enter a valid E-Mail Address (e.g., user@example.com)', 'warning');
            return;
        }

        // 수신자 이메일 주소 유효성 검사
        if (!isValidEmail(emailConfig.receiveAddress)) {
            showToast('Please enter a valid Receive E-Mail Address (e.g., user@example.com)', 'warning');
            return;
        }

        let sendData = {
            "email": {
                "use": emailConfig.used==="true",
                "protocol": emailConfig.protocol,
                "port": emailConfig.port,
                "server": emailConfig.server,
                "address": emailConfig.address,
                "password": emailConfig.password,
                "receiveAddress": emailConfig.receiveAddress
            },
            "slack": {
                "use": slackConfig.used==="true",
                "webhook": slackConfig.webhook
            },
            "teams": {
                "use": teamsConfig.used==="true",
                "webhook": teamsConfig.webhook
            },
            "telegram": {
                "use": telegramConfig.used==="true",
                "botToken": telegramConfig.botToken,
                "chatId": telegramConfig.chatId
            }
        };

        Promise.resolve( postApiConfigEndpoint(sendData) )
        .then( done => {
            getConfigEndpointRef.current = false;
            runUpdate();
        });
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() => {
        getEndpotintStatus();
    }, [update]);

    useEffect(() => {
        if( !getConfigEndpointRef.current ) return;

        setExistUpdate(
            JSON.stringify(emailConfig) !== JSON.stringify(emailOrigin)
            || JSON.stringify(slackConfig) !== JSON.stringify(slackOrigin)
            || JSON.stringify(teamsConfig) !== JSON.stringify(teamsOrigin)
            || JSON.stringify(telegramConfig) !== JSON.stringify(telegramOrigin)
        );
    }, [emailConfig, slackConfig, teamsConfig, telegramConfig, getConfigEndpointRef.current]);

    return (
        <div className="tab-pane show active">
            <div className="d-flex endpoint-icons my-2">
                <div className="d-flex align-items-center ms-4"><span className={`badge-dot ${emailConfig.color}`}></span><BsEnvelope/></div>
                <div className="d-flex align-items-center ms-5"><span className={`badge-dot ${slackConfig.color}`}></span><BsSlack/></div>
                <div className="d-flex align-items-center ms-5"><span className={`badge-dot ${teamsConfig.color}`}></span><BsMicrosoftTeams/></div>
                <div className="d-flex align-items-center ms-5"><span className={`badge-dot ${telegramConfig.color}`}></span><BsTelegram/></div>
            </div>
            <div className="section endpoint-area">
                <div className="email-area">
                    <div className="section-title">E-Mail</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Use</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                            <select className="form-select form-select-sm" value={emailConfig.used} onChange={(e) => {onChangeState(e, 'email', 'used', emailConfig)}}>
                                <option value={"false"}>Disabled</option>
                                <option value={"true"}>Enabled</option>
                            </select>
                        </div>
                        <button type="button" className="btn btn-success btn-sm ms-2" onClick={onClickEmailTest}>Test</button>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Protocol</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" disabled={emailConfig.used==="false"} value={emailConfig.protocol} onChange={(e) => {onChangeState(e, 'email', 'protocol', emailConfig)}}>
                                <option value="smtp">SMTP</option>
                            </select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Server</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" disabled={emailConfig.used==="false"} type="text" value={emailConfig.server} onChange={(e) => {onChangeState(e, 'email', 'server', emailConfig)}}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Port</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" disabled={emailConfig.used==="false"} type="text" value={emailConfig.port} onChange={(e) => {onChangeState(e, 'email', 'port', emailConfig)}}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">E-Mail Address</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" disabled={emailConfig.used==="false"} type="text" value={emailConfig.address} onChange={(e) => {onChangeState(e, 'email', 'address', emailConfig)}}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">E-Mail Password</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" disabled={emailConfig.used==="false"} type="password" value={emailConfig.password} onChange={(e) => {onChangeState(e, 'email', 'password', emailConfig)}}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Receive E-Mail Address</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" disabled={emailConfig.used==="false"} type="text" value={emailConfig.receiveAddress} onChange={(e) => {onChangeState(e, 'email', 'receiveAddress', emailConfig)}}/>
                        </div>
                    </div>
                </div>
                <div className="slack-area">
                    <div className="section-title mt-3">Slack</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Use</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                            <select className="form-select form-select-sm" value={slackConfig.used} onChange={(e) => {onChangeState(e, 'slack', 'used', slackConfig)}}>
                                <option value={"false"}>Disabled</option>
                                <option value={"true"}>Enabled</option>
                            </select>
                        </div>
                        <button type="button" className="btn btn-success btn-sm ms-2" onClick={onClickSlackTest}>Test</button>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box ">Webhook</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" disabled={slackConfig.used==="false"} type="text" value={slackConfig.webhook} onChange={(e) => {onChangeState(e, 'slack', 'webhook', slackConfig)}}/>
                        </div>
                    </div>
                </div>
                <div className="teams-area">
                    <div className="section-title mt-3">Teams</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Use</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                            <select className="form-select form-select-sm" value={teamsConfig.used} onChange={(e) => {onChangeState(e, 'teams', 'used', teamsConfig)}}>
                                <option value={"false"}>Disabled</option>
                                <option value={"true"}>Enabled</option>
                            </select>
                        </div>
                        <button type="button" className="btn btn-success btn-sm ms-2" onClick={onClickTeamsTest}>Test</button>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Webhook</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" disabled={teamsConfig.used==="false"} type="text" value={teamsConfig.webhook} onChange={(e) => {onChangeState(e, 'teams', 'webhook', teamsConfig)}}/>
                        </div>
                    </div>
                </div>
                <div className="telegram-area">
                    <div className="section-title mt-3">Telegram</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Use</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                            <select className="form-select form-select-sm" value={telegramConfig.used} onChange={(e) => {onChangeState(e, 'telegram', 'used', telegramConfig)}}>
                                <option value={"false"}>Disabled</option>
                                <option value={"true"}>Enabled</option>
                            </select>
                        </div>
                        <button type="button" className="btn btn-success btn-sm ms-2" onClick={onClickTelegramTest}>Test</button>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Bot token</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" disabled={telegramConfig.used==="false"} type="text" value={telegramConfig.botToken} onChange={(e) => {onChangeState(e, 'telegram', 'botToken', telegramConfig)}}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Chat Id</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" disabled={telegramConfig.used==="false"} type="text" value={telegramConfig.chatId} onChange={(e) => {onChangeState(e, 'telegram', 'chatId', telegramConfig)}}/>
                        </div>
                    </div>
                </div>
                <div className="d-flex my-2">
                    <Button variant="primary" className="btn btn-sm btn-badge-change" onClick={onClickSave}>Save<BadgeChange show={existUpdate}/></Button>
                    <span className={`ms-3 mt-1 text-warning ${existUpdate?"":"d-none"}`}>There are unsaved changes. Please click the Save button to apply your changes.</span>
                </div>
            </div>
            <LoadingSpinner loading={loading}/>
            {modalVisible&&<DecideWindow result={handleModalOk} show={modalVisible} handleClose={closeModalDecideForRoute} body={<SetDecideBodyMoveout />} okButtonTxt={'OK'}/>}
        </div>
    )
}